(function (app) {
    //Tested that it works when used with multiple different filters. Add this filter at the end to avoid conflicts ({{property.value | someFilter | addDash}})
    function fileSize() {
        return function (bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes === 0) return '-';
            if (typeof precision === 'undefined') precision = 1;
            var units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
        };
    }

    fileSize.$inject = [];
    app.filter("fileSize", fileSize);

})(window.app); //jshint ignore:line